import Fluxxor from 'fluxxor';
import {STATUS_INITIAL, STATUS_SUCCESS, STATUS_PENDING} from '../../constants';
import lscache from 'lscache';
import {CACHE_KEYS} from '../../constants';
import mapValues from '../../utils/arraysHelper';
import isAfter from 'date-fns/isAfter';
import parseISO from 'date-fns/parseISO';

export const constants = {
  FETCH_TOP_DESTINATIONS: 'FETCH_TOP_DESTINATIONS',
  FETCH_COUNTRIES: 'FETCH_COUNTRIES',
  FETCH_COUNTRIES_SUCCESS: 'FETCH_COUNTRIES_SUCCESS',
  FETCH_APPROVED_LOCATIONS_SUCCESS: 'FETCH_APPROVED_LOCATIONS_SUCCESS',
};

export const LocationsStore = Fluxxor.createStore({
  initialize() {
    this.topDestinations = {
      status: STATUS_INITIAL,
      data: [],
    };

    this.countries = {
      status: STATUS_INITIAL,
      data: [],
    };

    this.approvedLocations = lscache.get(CACHE_KEYS.LOCATION.APPROVED_LOCATIONS) || {
      status: STATUS_INITIAL,
      data: [],
    };

    this.bindActions(
      constants.FETCH_TOP_DESTINATIONS, this.onFetchTopDestinationsSuccess,
      constants.FETCH_COUNTRIES, this.onFetchCountries,
      constants.FETCH_COUNTRIES_SUCCESS, this.onFetchCountriesSuccess,
      constants.FETCH_APPROVED_LOCATIONS_SUCCESS, this.onFetchApprovedLocationsSuccess,
    );
  },

  onFetchTopDestinationsSuccess(destinations) {
    this.topDestinations = {
      status: STATUS_SUCCESS,
      data: destinations,
    };

    this.emit('change');
  },

  onFetchCountries() {
    this.countries = {
      ...this.countries,
      status: STATUS_PENDING,
    };

    this.emit('change');
  },

  onFetchCountriesSuccess(countries) {
    countries = countries.sort((a, b) => {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    });
    this.countries = {
      status: STATUS_SUCCESS,
      data: countries,
    };

    this.emit('change');
  },

  onFetchApprovedLocationsSuccess(locations) {
    const now = new Date();
    this.approvedLocations = {
      status: STATUS_SUCCESS,
      data: locations
        .map((location) => mapValues(location, (value) => !!value && value.toLowerCase ? value.toLowerCase() : value))
        .map(f => ({
          ...f,
          isComingSoon: f.launch_date ? isAfter(parseISO(f.launch_date), now) : false,
        })),
    };
    this.emit('change');
  },

  getCountries() {
    return this.countries;
  },

  getTopDestinations() {
    return this.topDestinations;
  },

  getApprovedLocations() {
    return this.approvedLocations;
  },
});
